import {TranslateResult} from 'vue-i18n';
import i18n from '@/plugins/i18n';

const emailValidationRegex = /.+@.+\..+/

export function validateEmail(v: string): boolean | TranslateResult {
  return emailValidationRegex.test(v) || i18n.t('validation.emailMustBeValid')
}

export function valueIsRequired(v: string): boolean | TranslateResult {
  return !!v || i18n.t('validation.valueIsRequired')
}

export function checkPasswordLength(v: string): boolean | TranslateResult {
  return v && v.length >= 4 || i18n.t('validation.passwordMinimumLength')
}
